export const iOSDevice = () => navigator.platform.match(/iPhone|iPod|iPad/u);

export const isDesktopMedia = () => window.matchMedia('(min-width: 979px)').matches;

export const isNewDesktopMedia = () => window.matchMedia('(min-width: 1021px)').matches;

export const desktopLargeMedia = () => window.matchMedia('(min-width: 1440px)');

export const isDesktopLargeMedia = () => desktopLargeMedia().matches;

export const isDesktopSmallMedia = () => window.matchMedia('(min-width: 481px)').matches;

export const isDesktop = () => isDesktopMedia();

export const isNewDesktop = () => isNewDesktopMedia();

export const isDesktopLarge = () => isDesktopLargeMedia();

export const isDesktopSmall = () => isDesktopSmallMedia();
